import i18next from 'i18next';
import LOCALE from '@app/configs/locale';
export const getSolvencyDeclarationLocale = () => {
    const userLocale = i18next.language;
    const locale = LOCALE.LOCALES.includes(userLocale) ? userLocale : LOCALE.DEFAULT_LOCALE;
    return locale;
};
